export default {
  index: "首页",
  news: "新闻",
  signout: "登出",
  find: "发现",
  confirmText: "确定",
  cancelText: "取消",
  login: {
    account: "账号",
    accountplaceholder: "请输入账号",
    password: "密码",
    passwordplaceholder: "请输入密码",
    sign: "登录",
    register: "注册",
    forpassword: "忘记密码",
    emailplaceholder: "请输入电子邮件地址",
    RegisterCodeText: "请输入四位验证码",
    RegisterEmailText: "验证码已发送至 ",
    resend: "重新发送",
    previousStep: "上一步",
    nextStep: "下一步",
    setpassword: "请设置登入密码",
    setpasswordTip: "密码为6至9位字母、数字组合",
    signPassword: "登入密码",
    resignPassword: "重复登入密码",
    resignPasswordConfirm: "请再次确认密码",
    confirm: "确认",
    sendRePasswordEmail: "发送重置密码邮件",
    resignPasswordSendSuccessText: "已发送重置密码邮件，请根据提示操作",
    SetresignPasswordSuccessText: "设置登入密码成功",
    toSign: "前往登入",
    resend60s: "60秒后可重新发送",
    emailTip: "请输入正确的电子邮件",
    vcode: "验证码：",
    setpasswordtext: "设置密码",
    passwordTip: "请输入正确格式密码",
    passwordErrorTip: "密码输入不一致",
    SetSuccessText: "设置成功",
    inputaccpass: "请输入账号密码",
    emailReg: "电子邮件验证和注册",
    sresend: "秒后可重新发送"
  },
  product: {
    firm: "厂商",
    download: "下载",
    recharge: "充值",
    rechargeActivity: "充值活动",
    introduction: "简介",
    preview: "预览",
    recentUpdates: "最近更新",
    information: "详细信息",
    fileSize: "文件大小",
    version: "当前版本",
    updateTime: "更新时间"
  },
  publishType: {
    0: "活动福利",
    1: "新游上线",
    2: "攻略专题"
  },
  gamelist: {
    allGame: "全部游戏",
    hotGame: "热门游戏",
    retract: "收起",
    more: "更多"
  },
  QRCode: {
    FindGame: "solaplay 发现好游戏",
    follow: "登录关注我们",
    RecentRecharge: "快速充值",
    signreg: "登录/注册",
    relatedGames: "相关游戏",
    LoginBtnTextCont: "登入后可记录充值历史，方便快速充值",
    LoginUserInfo: "您还没有充值历史,快去充值一笔吧"
  },
  reSetPassword: {
    SetresignPasswordSuccessText: "密码修改成功,请登录"
  },
  setPassword: {
    settingPassword: "请设置登录密码",
    settingNewPassword: "请设置新的登录密码",
    passwordLimit: "密码为6至9位字母、数字组合",
    inpPassword: "登录密码（必填）",
    rinpPassword: "重复登录密码（必填）",
    pwdtipnull: "密码不能为空",
    pwdtip: "密码格式不符合要求",
    rpwdtip: "两次输入的密码不同"
  },
  feet: {
    title1: "游戏官方授权社区平台，支持googleplay与appstore官方app，100%放心",
    title2:
      "注册登录solaplay，可绑定游戏角色，使用官方充值通道快速充值，免除繁琐操作",
    title3: "随时随地获取最新游戏官方活动信息与福利",
    qrdown: "二维码下载",
    download: "免费下载"
  },
  interact: {
    1: "Mạng không ổn định, vui lòng thử lại sau",
    2: "Đang yêu cầu",
    3: "Về trang đăng nhập",
    4: "Hệ thống khác thường, vui lòng thử lại sau",
    5: "Tài khoản không thể trống",
    6: "Mật mã không thể trống",
    7: "Đăng ký lại",
    8: "Ok",
    9: "Tài khoản không tồn tại",
    10: "Vào đăng nhập/Đăng ký",
    11: "Dịch vụ nạp game này do Scode cung cấp, hãy đăng nhập hoặc đăng ký tài khoản Scode",
    12: "Tải khoản chưa đăng nhập",
    13: "Không tìm được nhân vật",
    14: "Yêu cầu khác thường hãy thử lại sau",
    15: "登录超时请重新登录",
    E502572099999: "Hệ thống khác thường",
    E502572000001: "Kiểm chứng chữ ký không được duyệt",
    E502572000002: "ACCESSTOKEN lặp lại",
    E502572000003: "Giải mã dữ liệu nhạy cảm lỗi",
    E502573000004: "Tham số yêu cầu sai",
    E502576000005: "Mã kiểm chứng sai",
    E502576000006: "Mật mã đăng nhập sai",
    E502572000007: "Không thể đăng nhập",
    E502576000008: "Tài khoản chưa đăng nhập",
    E502576000009: "此账号已注册，请直接登录",
    E502576000010: "Chưa đăng ký",
    E502576000011: "Liên kết thất bại hoặc không thể liên kết",
    E80000000001: "Mã chi trả sai",
    C301100000000: "Thành công",
    E301107100004: "đơn đặt không tồn tại",
    E301105100007: "đơn đặt thất bại",
    E301107100017: "Hệ thống bận, hãy thử lại sau",
    E301107100023: "đơn đặt này đã chi trả vui lòng không lặp lại chi trả",
    EC301105100007: "Mã kiểm chứng thất bại, hãy nhận lại mã kiểm chứng",
    EC01105100008: "Mã kiểm chứng sai, hãy nhập lại",
    "0000": "Giao dịch thành công",
    "0008": "Không có tài khoản này",
    "0002": "Trạng thái tài khoản khác thường",
    "9991": "Giao dịch vô hiệu, Text thông báo khác thường",
    "0014": "Merchant vô hiệu, người dùng không có tài khoản chi trả",
    "0007": "Mã đơn đặt lặp lại",
    "0006": "Hạn mức không đúng",
    "9999": "Phân phối hệ thống lỗi, không có tham số kiểm chứng mật mã",
    "0013": "Kiểm chứng mật mã thất bại",
    "0018": "Không có tài khoản này, tài khoản rút",
    "0010": "Trạng thái tài khoản khác thường, tài khoản rút",
    "0019": "Không có tài khoản này, tài khoản gửi",
    "0011": "Trạng thái tài khoản khác thường, tài khoản gửi",
    "0003": "Số dư không đủ",
    "0000": "Yêu cầu thành công",
    E202000200004: "Hệ thống lỗi",
    E200000000021: "Kiểm chứng tham số thất bại",
    E200000000017: "Khác thường"
  }
};



// WEBPACK FOOTER //
// ./src/language/zh.js